import { Dexie, type EntityTable } from 'dexie';

type SongbookColor = 'default' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning';

interface Songbook {
  id: string;
  title: string;
  color: SongbookColor;
  createdAt: Date;
  updatedAt: Date;
  lastUsed: Date;
}

interface Song {
  id: string;
  songbookId: string;
  orientation: 'horizontal' | 'vertical';
  title: string;
  artist?: string;
  key?: string;
  tempo?: number;
  order: number;
  createdAt: Date;
  updatedAt: Date;
  lastUsed: Date;
}

type SongMediaColumnWidth = 'auto' | '2/3' | '1/2' | '1/3' | '1/4';

interface SongMediaBase {
  id: string;
  originalId?: string;
  songId: string;
  options?: Record<string, number | boolean | string>;
  order: number;
  width?: SongMediaColumnWidth;
}

interface SongMediaImage extends SongMediaBase {
  type: 'image';
  contents: ArrayBuffer;
}

interface SongMediaAudio extends SongMediaBase {
  type: 'audio';
  contents: ArrayBuffer;
  options?: Partial<{
    speed: number;
    repeat: boolean;
  }>;
}

interface SongMediaVideo extends SongMediaBase {
  type: 'video';
  contents: ArrayBuffer;
}

interface SongMediaVideoLink extends SongMediaBase {
  type: 'videoLink';
  contents: string;
}

type SongMedia = SongMediaAudio | SongMediaImage | SongMediaVideo | SongMediaVideoLink;

const db = new Dexie('ChordMage') as Dexie & {
  songbooks: EntityTable<Songbook, 'id'>;
  songs: EntityTable<Song, 'id'>;
  media: EntityTable<SongMedia, 'id'>;
}

// Schema declaration:
db.version(1).stores({
  songbooks: '&id, title, color, createdAt, updatedAt, lastUsed',
  songs: '&id, songbookId, media, title, artist, key, tempo, order, createdAt, updatedAt, lastUsed',
  media: '&id, songId, type, contents, options, order, width',
})

export type {
  Songbook,
  Song,
  SongbookColor,
  SongMedia,
  SongMediaAudio,
  SongMediaImage,
  SongMediaVideo,
  SongMediaVideoLink,
  SongMediaColumnWidth,
};

export { db };
